import React from 'react';
import { Backdrop, Slide } from '@mui/material';
import ConfirmacaoNaoCompareceuDialog from './ConfirmacaoNaoCompareceuDialog';
import ChamarSenhaEspecificaDialog from './ChamarSenhaEspecificaDialog';
import EnviarParaAtendenteModal from '../painel-recepcao/EnviarParaAtendenteModal';
import AlterarServicoModal from './AlterarServicoModal';
import ConfirmarAlteracaoServicoModal from './ConfirmarAlteracaoServicoModal';

// Transição personalizada no estilo iOS para o Dialog
const IOSSlideTransition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DashboardDialogs = ({
  // Estados dos diálogos
  dialogoAberto,
  dialogoReabrirSenhaAberto,
  dialogoChamarSenhaEspecifica,
  dialogoAlterarServicoAberto,
  dialogoConfirmarAlteracaoAberto,
  
  // Dados
  senhaChamada,
  senhaSelecionada,
  acaoEscolhida,
  atendenteEscolhido,
  customTheme,
  
  // Handlers dos diálogos
  handleCancelarNaoCompareceu,
  handleConfirmarNaoCompareceu,
  handleCancelarReabrirSenha,
  handleConfirmarReabrirSenha,
  handleCancelarChamarSenhaEspecifica,
  handleConfirmarChamarSenhaEspecifica,
  handleEnviarParaAtendente,
  handleEscolherAtendente,
  handleMostrarDialogoAlterarServico,
  handleCancelarAlterarServico,
  handleNaoAlterarServico,
  handleSimAlterarServico,
  handleConfirmarAlteracaoComNovoServico,
  handleCancelarConfirmacaoAlteracao,
  buscarSenhas
}) => {
  return (
    <>
      {/* Diálogo de confirmação de não comparecimento */}
      <ConfirmacaoNaoCompareceuDialog
        open={dialogoAberto}
        onClose={handleCancelarNaoCompareceu}
        onConfirm={handleConfirmarNaoCompareceu}
        senha={senhaChamada}
        customTheme={customTheme}
        TransitionComponent={IOSSlideTransition}
        Backdrop={Backdrop}
      />

      {/* Modal de reabertura com opcoes (fila ou atendente) */}
      <EnviarParaAtendenteModal
        open={dialogoReabrirSenhaAberto}
        onClose={handleCancelarReabrirSenha}
        onConfirm={handleEscolherAtendente}
        senha={senhaChamada}
        mostrarOpcaoVoltarFila={true}
        onVoltarParaFila={handleConfirmarReabrirSenha}
        tituloPersonalizado="Reabrir Senha - Escolha uma opção"
      />

      {/* Modal de confirmação: "Deseja alterar serviço?" */}
      <ConfirmarAlteracaoServicoModal
        open={dialogoConfirmarAlteracaoAberto}
        onClose={handleCancelarConfirmacaoAlteracao}
        onSimAlterarServico={handleSimAlterarServico}
        onNaoAlterarServico={handleNaoAlterarServico}
        senha={senhaChamada}
        acaoEscolhida={acaoEscolhida}
        atendenteEscolhido={atendenteEscolhido}
        customTheme={customTheme}
        TransitionComponent={IOSSlideTransition}
        Backdrop={Backdrop}
      />

      {/* Modal para alterar serviço da senha */}
      <AlterarServicoModal
        open={dialogoAlterarServicoAberto}
        onClose={handleCancelarAlterarServico}
        onConfirm={handleConfirmarAlteracaoComNovoServico}
        senha={senhaChamada}
        customTheme={customTheme}
        TransitionComponent={IOSSlideTransition}
        Backdrop={Backdrop}
      />

      {/* Diálogo para confirmar chamada de senha específica */}
      <ChamarSenhaEspecificaDialog
        open={dialogoChamarSenhaEspecifica}
        onClose={handleCancelarChamarSenhaEspecifica}
        onConfirm={handleConfirmarChamarSenhaEspecifica}
        senha={senhaSelecionada}
        customTheme={customTheme}
        TransitionComponent={IOSSlideTransition}
        Backdrop={Backdrop}
      />
    </>
  );
};

export default DashboardDialogs;